export class Video {
  public id: number;
  public name: string;
  public path: string;
  public video_folder_id: number;
}
